import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import { R } from '@core/utils/r';
import { Checkbox, checkboxClasses, FormControlLabel } from '@mui/material';
import React, { CSSProperties, memo, useMemo, ReactNode } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

const theme = {
  overrides: {
    MuiCheckbox: {
      root: {
        color: 'white',
      },
      colorSecondary: {
        '&$checked': {
          color: 'white',
        },
      },
    },
  },
};
export type FormCheckboxMaterialProps = FieldProps<FormControl<boolean>> & {
  onChange?(value: boolean): void;
  noPadding?: boolean;
  link?: string | null;
  description?: string;
  container?: string;
  style?: CSSProperties;
  children?: ReactNode;
  noClasses?: boolean;
  className?: string;
  value?: any;
};

export const FormCheckboxMaterial = memo((props: FormCheckboxMaterialProps) => {
  const { formControl, fieldState, fieldConfig } = useFormField(props);

  const fieldValue = fieldState.value || false;

  const fieldReadonly = fieldConfig.readonly || false;
  const fieldDisabled = fieldConfig.disabled || false;
  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const hasLink = useMemo(() => {
    return !R.isEmpty(props.link);
  }, [props.link]);

  const uid = useMemo(() => R.random(100, 10000), []);
  const classes = useMemo(
    () => (props.noClasses ? '' : `custom-control custom-checkbox custom-checkbox-primary ${props.className || ''} `),
    [props.noClasses, props.className],
  );
  return (
    <React.Fragment>
      <div className={classes} style={props.style}>
        <FormControlLabel
          style={{ fontFamily: 'Poppins' }}
          control={
            <Checkbox
              sx={{
                color: 'white',
                [`&, &.${checkboxClasses.checked}`]: {
                  color: 'white',
                },
              }}
              name={formControl.uid}
              id={`${formControl.uid}`}
              checked={fieldValue}
              onChange={event => {
                formControl.setValue(event.target.checked);
                props.onChange && props.onChange(event.target.checked);
              }}
            />
          }
          label={<div>{fieldConfig.label}</div>}
        />
        {!!props.description && (
          <span className="text-primary ml-2 hover-pointer" id={`tt-${uid}`}>
            <i className="fa fa-question-circle font-size-16" />
            <UncontrolledTooltip container={props.container} placement="top" target={`tt-${uid}`}>
              {props.description}
            </UncontrolledTooltip>
          </span>
        )}
      </div>

      {hasLink && (
        <a href={props.link!} className="1custom-control-label" target="_blank" rel="noopener noreferrer">
          {fieldConfig.label}
        </a>
      )}
    </React.Fragment>
  );
});
